import React from 'react';
import { InputProps } from '../InputInterface';

const InputForm: React.FC<InputProps> = ({ name, placeholder, value, onChange, type = 'text' }) => {
  return (
    <>
      <style>{`
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        input[type=number] {
          -moz-appearance: textfield;
        }

        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus,
        input:-webkit-autofill:active {
          -webkit-text-fill-color: #1f2937 !important;
          transition: background-color 5000s ease-in-out 0s;
        }
      `}</style>
      <input
        type={type}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="flex-grow px-4 md:px-6 py-3 md:py-4 bg-transparent border-none focus:ring-0 focus:outline-none text-base md:text-lg text-gray-800 placeholder-gray-500 w-full"
      />
    </>
  );
};

export default InputForm;
